import { toast } from '@/components/ui/use-toast'
import { EstateForDocumentsPageFragment, useUpdateEstateMutation } from '@gql'
import debounce from 'lodash.debounce'
import React, { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { EstateDiagnosticsDataForm } from './EstateDiagnosticsDataForm'
import { EstateDiagnosticsMediaList } from './EstateDiagnosticsMediaList'

export type EstateDiagnosticsTabProps = {
  estate: Pick<EstateForDocumentsPageFragment, 'id' | 'diagnosticsData'>
  readonly: boolean
}
export const EstateDiagnosticsTab = ({
  estate,
  readonly,
}: EstateDiagnosticsTabProps) => {
  const { t } = useTranslation()
  const [
    updateEstate,
    {
      data: updateEstateData,
      // loading: updateEstateLoading,
      error: updateEstateError,
    },
  ] = useUpdateEstateMutation({
    refetchQueries: ['getEstates'],
  })

  useEffect(() => {
    if (updateEstateData) {
      toast({
        variant: 'success',
        description: t('EstateDiagnosticsTab.toast.success'),
      })
    }
  }, [updateEstateData])

  useEffect(() => {
    if (updateEstateError) {
      toast({
        variant: 'destructive',
        description: t('EstateDiagnosticsTab.toast.error'),
      })
    }
  }, [updateEstateError])

  const debouncedUpdateEstate = useMemo(
    () =>
      debounce((values: Partial<EstateForDocumentsPageFragment>) => {
        updateEstate({
          variables: {
            id: estate.id,
            values,
          },
        })
      }, 500),
    [estate.id, updateEstate]
  )

  return (
    <>
      <h2 className="tw-text-2xl tw-font-semibold tw-mb-5">
        {t('EstateDiagnosticsTab.title')}
      </h2>
      <div className="tw-flex tw-flex-col tw-gap-4 tw-w-[650px]">
        <EstateDiagnosticsMediaList estateId={estate.id} readonly={readonly} />
        <EstateDiagnosticsDataForm
          estate={estate}
          onSubmit={debouncedUpdateEstate}
          readonly={readonly}
        />
      </div>
    </>
  )
}
